import { CombinedFunnelMobileCodeDestination } from './CodeDestination/CodeDestination'
import { CombinedFunnelMobileGenerateCode } from './GenerateCode'
import { IndividualStep, UseCombinedFunnelMobileV1State } from './CombinedFunnelMobile.types'
import { PageType } from '@dtx-company/flow-codegen/src/page/generated.types'
import { defaultPageAttributes } from '@dtx-company/true-common/src/constants/page'
import { initDemoPage } from '@dtx-company/inter-app/src/redux/slices/pageEditor/pageEditorSlice'
import { setHideFooter } from '@dtx-company/inter-app/src/redux/slices/settings-slice'
import { setShowStaticContent } from '@dtx-company/inter-app/src/redux/slices/homePageSlice'
import { useCurrentPage } from '@dtx-company/inter-app/src/redux/slices/utils/currentPage'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'

export const MOBILE_VARIANT_STEPS: Record<number, IndividualStep> = {
  1: {
    component: CombinedFunnelMobileCodeDestination,
    label: 'code_destination',
    showNextButton: false
  },
  2: {
    component: CombinedFunnelMobileGenerateCode,
    label: 'auth',
    showNextButton: false
  }
}

export function useCombinedFunnelMobileV1State(): UseCombinedFunnelMobileV1State {
  const steps = MOBILE_VARIANT_STEPS

  const [currStep, setCurrStep] = useState(1)
  const [allowNextStep, setAllowNextStep] = useState(false)
  const dispatch = useDispatch()

  const { component, showProgress = true, showNextButton = true, label } = steps[currStep]

  const showBackButton = showProgress && currStep > 1
  const totalSteps = Object.keys(steps).length

  useEffect(() => {
    dispatch(setHideFooter(true))
    dispatch(setShowStaticContent(false))
    return function cleanupSteppedMobileFlowcodeFlow() {
      dispatch(setHideFooter(false))
      dispatch(setShowStaticContent(true))
    }
  }, [dispatch])

  const handleBack = (): void => {
    setCurrStep(prevStep => prevStep - 1)
    events.Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Back_Btn({
      screen: label
    })
  }

  const advanceStep = (): void => {
    setCurrStep(prevStep => prevStep + 1)
    events.Flowcode_Combined_Funnel_Mobile_Homepage_Clicked_Next_Btn({
      screen: label
    })
  }

  return {
    Component: component,
    componentId: label,
    showBackButton,
    showNextButton,
    allowNextStep,
    currStep,
    totalSteps,
    showProgressBar: showProgress,
    setCurrStep,
    setAllowNextStep,
    handleBack,
    advanceStep
  }
}

export function useCombinedFunnelMobileInitializePage(): void {
  const router = useRouter()
  const { query } = router
  const dispatch = useDispatch()
  const pageType = (query.pageType as PageType) ?? PageType.Default
  const page = useCurrentPage()

  useEffect(() => {
    if (!page) {
      dispatch(
        initDemoPage({
          page: {
            ...defaultPageAttributes,
            theme: {
              ...defaultPageAttributes.theme
            },
            pageType,
            slugName: 'placeholder-slug'
          }
        })
      )
    }
  }, [dispatch, pageType, page])
}
